import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, useAuth } from "../lib/api";
import { Button, Input, Label } from "../components/ui";

export default function ChangePassword() {
  const { user, refresh, logout } = useAuth();
  const nav = useNavigate();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(null);
    if (pw !== pw2) { setErr("passwords do not match"); return; }
    setBusy(true);
    try { await api("/auth/change-password", { method: "POST", body: { current_password: cur, new_password: pw } }); toast.success("password updated"); await refresh(); nav("/"); }
    catch (ex) { setErr(ex.message); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center relative">
      <div className="cx-mesh-bg"><div className="cx-mesh-blob cx-mesh-blob-1" /><div className="cx-mesh-blob cx-mesh-blob-2" /></div>
      <form onSubmit={submit} className="cx-card cx-card-static cx-glass relative z-10 w-[min(440px,92vw)] p-8 space-y-4" data-testid="change-password-form">
        <div><div className="cx-gradient-text text-2xl font-bold tracking-tight">Set a new password</div><div className="text-xs text-cx-muted mt-1">{user?.must_change_password ? "Your account was created with a temporary password. Choose your own before continuing." : "Update your password."} Minimum 12 characters.</div></div>
        <div className="text-xs text-cx-muted">Signed in as <span className="cx-mono">{user?.email}</span></div>
        <div><Label htmlFor="cur">Current (temporary) password</Label><Input id="cur" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required data-testid="cp-current" /></div>
        <div><Label htmlFor="pw">New password</Label><Input id="pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={12} data-testid="cp-new" /></div>
        <div><Label htmlFor="pw2">Repeat new password</Label><Input id="pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required data-testid="cp-repeat" /></div>
        {err && <div className="cx-form-error" data-testid="cp-error">{err}</div>}
        <Button type="submit" className="w-full justify-center" disabled={busy} data-testid="cp-submit">{busy ? "Saving…" : "Save password"}</Button>
        <button type="button" className="text-xs text-cx-muted underline w-full" onClick={() => logout().then(() => nav("/login"))} data-testid="cp-logout">Sign out instead</button>
      </form>
    </div>
  );
}
